const i18n = {
    VIDEO_ACQUIRING_LICENSE: {
        en: 'Acquiring license..',
        nl: 'Ophalen licentie..',
    },
    VIDEO_BUFFERING: {
        en: 'Buffering...',
        nl: 'Bufferen...',
    },
    VIDEO_ACQUIRING_MANIFEST: {
        en: 'Retrieving manifest..',
        nl: 'Ophalen manifest...',
    },
    INITIALIZING: {
        en: 'Initializing',
        nl: 'Initialiseren',
    },
    NONE: {
        en: 'None',
        nl: 'Geen',
    },
};
export default i18n;



// WEBPACK FOOTER //
// ./src/js/localization/i18n.js